<template>
  <div data-testid="checks-secion-panel" class="tw-flex tw-flex-col tw-gap-4">
    <SfAssistantCheck
      v-for="checkId in groupedCheckIds?.[workflowId]?.[contextId]"
      :key="checkId"
      :check="assistantChecks[checkId]"
      :read="checkReadStatus[checkId]"
      :read-by-users="checkReadByUsers[checkId]"
    />
    <slot name="after-checks" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import SfAssistantCheck from '@app/application/sf-assistant-checks/components/sf-assistant-check.vue'
import { useSfAssistantChecksPage } from '../stores/page'
import { useAssistantChecksStore } from '@app/application/sf-assistant-checks/stores/assistant-checks'

interface Props {
  workflowId: string
  contextId: string
}

defineProps<Props>()

const pageStore = useSfAssistantChecksPage()
const assistantChecksStore = useAssistantChecksStore()
const { assistantChecks } = storeToRefs(assistantChecksStore)

onMounted(() => {
  assistantChecksStore.initFromPageStore()
})

const { checkReadStatus, checkReadByUsers, groupedCheckIds } =
  storeToRefs(pageStore)
</script>
